<div class="inicio" [class.inicio--scrolled]="scrolled()" [class.inicio--anim]="animacionesActivas()">
  <a class="inicio-skip" href="#inicio-contenido">Saltar al contenido</a>

  <header class="inicio-header">
    <div class="inicio-wrap mx-auto flex align-items-center justify-content-between gap-3 py-3">
      <a
        routerLink="/"
        class="inicio-marca inline-flex align-items-center no-underline"
        aria-label="Mayorap, volver al inicio"
        translate="no"
      >
        <img
          src="assets/marca/mayorap-logo-negro.png"
          alt="Mayorap"
          width="1024"
          height="288"
          decoding="async"
        />
      </a>
      <nav class="hidden md:flex align-items-center gap-4" aria-label="Secciones">
        <button type="button" class="inicio-nav cursor-pointer border-none bg-transparent" (click)="irA('quienes')">Quiénes somos</button>
        <button type="button" class="inicio-nav cursor-pointer border-none bg-transparent" (click)="irA('funciones')">Funciones</button>
        <button type="button" class="inicio-nav cursor-pointer border-none bg-transparent" (click)="irA('graficos')">Gráficos</button>
        <button type="button" class="inicio-nav cursor-pointer border-none bg-transparent" (click)="irA('contacto')">Contacto</button>
      </nav>
      <p-button
        [routerLink]="rutaEntrada"
        [label]="conSesion ? 'Entrar' : 'Iniciar sesión'"
        [icon]="conSesion ? 'pi pi-arrow-right' : 'pi pi-sign-in'"
      />
    </div>
  </header>

  <main id="inicio-contenido">
    <section class="inicio-hero relative">
      <div class="inicio-hero-motif" aria-hidden="true">
        <span class="inicio-anillo inicio-anillo-1"></span>
        <span class="inicio-anillo inicio-anillo-2"></span>
        <span class="inicio-anillo inicio-anillo-3"></span>
      </div>
      <div class="inicio-wrap mx-auto grid align-items-center relative z-1">
        <div class="col-12 lg:col-6 inicio-entrada">
          <p-tag value="Para iglesias evangélicas" [rounded]="true" />
          <h1 class="inicio-titulo font-bold m-0 mt-3">Potenciando el mensaje más importante del mundo.</h1>
          <p class="inicio-lead text-lg line-height-3 m-0 mt-3">
            Una plataforma para que el Pastor tenga una visión clara de su iglesia, mientras el
            administrador y los líderes mantienen la información ordenada y actualizada.
          </p>
          <div class="flex flex-wrap gap-2 mt-4">
            <p-button
              [routerLink]="rutaEntrada"
              [label]="conSesion ? 'Entrar' : 'Iniciar sesión'"
              [icon]="conSesion ? 'pi pi-arrow-right' : 'pi pi-sign-in'"
            />
            <p-button
              type="button"
              label="Ver funciones"
              icon="pi pi-arrow-down"
              [outlined]="true"
              (onClick)="irA('funciones')"
            />
          </div>
        </div>
        <div class="col-12 lg:col-6 inicio-entrada inicio-entrada-tarde">
          <div class="inicio-hero-stage">
            <div class="inicio-hero-shutter relative z-1 overflow-hidden">
              <img
                class="inicio-foto inicio-foto-hero relative z-1 block w-full h-auto"
                src="assets/inicio/hero.jpg"
                alt="Computadora y teléfono con gráficos de asistencia"
                width="1280"
                height="720"
                fetchpriority="high"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="quienes" class="inicio-bloque inicio-bloque-quienes" aria-labelledby="quienes-titulo">
      <div class="inicio-wrap mx-auto inicio-quienes grid align-items-center">
        <div class="col-12 lg:col-6 inicio-quienes-visual relative flex justify-content-center inicio-revelar">
          <div class="inicio-quienes-media relative w-full max-w-22rem md:max-w-30rem">
            <div class="inicio-quienes-orbit pointer-events-none absolute top-0 right-0 bottom-0 left-0 z-0" aria-hidden="true">
              <span></span>
              <span></span>
            </div>
            <div class="inicio-quienes-frame relative z-1 w-full h-full overflow-hidden border-circle">
              <img
                #quienesFoto
                class="inicio-foto inicio-foto-adoracion"
                src="assets/inicio/adoracion.png"
                alt="Congregación de espaldas, con las manos en alto, frente a una cruz"
                width="600"
                height="454"
                loading="lazy"
                decoding="async"
              />
            </div>
            <p class="inicio-quienes-chip absolute z-3 inline-flex align-items-center white-space-nowrap font-semibold m-0">Más de 100 personas · una sola mirada</p>
          </div>
        </div>

        <div class="col-12 lg:col-6 inicio-quienes-copy relative inicio-revelar" style="transition-delay: 120ms">
          <p-tag value="Quiénes somos" [rounded]="true" />
          <h2 id="quienes-titulo" class="font-bold m-0 mt-3">Nacimos de una necesidad real de la iglesia.</h2>
          <p class="m-0 mt-3 line-height-3">
            Todo comenzó con un programador que, en su propia iglesia, vio cómo se entregaba la
            planilla de una célula. Era información valiosa, pero quedaba en una hoja difícil de
            cruzar con las demás. Entonces surgió una pregunta simple: ¿qué pasaría si todas esas
            planillas estuvieran conectadas?
          </p>
          <p class="m-0 mt-3 line-height-3">
            Así nació Mayorap: para transformar la información de cada célula en una visión
            completa de la congregación. Una herramienta que permite analizar los datos, generar
            gráficos y llamar la atención sobre los valores que necesitan ser vistos.
          </p>
          <blockquote class="inicio-quienes-proposito font-medium m-0 mt-4">
            Nuestro propósito es que ninguna persona se aparte de forma invisible. Cuando alguien
            entra en una lucha con congregar, la iglesia necesita información para acompañarla a
            tiempo.
          </blockquote>
        </div>
      </div>
    </section>

    <section id="domingo" class="inicio-bloque inicio-bloque-suave py-6" aria-labelledby="domingo-titulo">
      <div class="inicio-wrap mx-auto">
        <div class="inicio-encabezado mb-2 inicio-revelar">
          <p-tag value="El domingo" [rounded]="true" />
          <h2 id="domingo-titulo" class="font-bold m-0 mt-3">El administrador organiza. El Pastor ve y decide.</h2>
        </div>
        <div class="grid mt-2">
          @for (paso of pasos; track paso.titulo; let i = $index) {
            <div class="col-12 md:col-4 inicio-revelar" [style.transition-delay.ms]="i * 90">
              <p-card styleClass="h-full inicio-panel">
                <span class="inicio-numero inline-flex align-items-center justify-content-center border-circle font-bold">0{{ i + 1 }}</span>
                <h3 class="m-0 mt-3 text-lg">{{ paso.titulo }}</h3>
                <p class="m-0 mt-2 text-sm line-height-3 text-color-secondary">{{ paso.texto }}</p>
              </p-card>
            </div>
          }
        </div>
      </div>
    </section>

    <section id="funciones" class="inicio-bloque py-6" aria-labelledby="funciones-titulo">
      <div class="inicio-wrap mx-auto">
        <div class="inicio-encabezado mb-2 inicio-revelar">
          <p-tag value="Funciones" [rounded]="true" />
          <h2 id="funciones-titulo" class="font-bold m-0 mt-3">Todo lo que el Pastor necesita ver.</h2>
        </div>
        <div class="grid mt-2">
          @for (item of funciones; track item.titulo; let i = $index) {
            <div class="col-12 md:col-6 xl:col-4 inicio-revelar" [style.transition-delay.ms]="i * 70">
              <p-card styleClass="h-full inicio-panel">
                <span class="inicio-icono inline-flex align-items-center justify-content-center border-circle" aria-hidden="true"><i [class]="item.icon"></i></span>
                <h3 class="m-0 mt-3 text-lg">{{ item.titulo }}</h3>
                <p class="m-0 mt-2 text-sm line-height-3 text-color-secondary">{{ item.texto }}</p>
              </p-card>
            </div>
          }
        </div>
      </div>
    </section>

    <section id="graficos" class="inicio-bloque inicio-bloque-suave py-6" aria-labelledby="graficos-titulo">
      <div class="inicio-wrap mx-auto">
        <div class="grid align-items-center">
          <div class="col-12 lg:col-6 inicio-revelar">
            <p-tag value="Gráficos" [rounded]="true" />
            <h2 id="graficos-titulo" class="font-bold m-0 mt-3">Una lectura clara de lo que está pasando.</h2>
            <p class="m-0 mt-3 line-height-3">
              Los gráficos y resúmenes convierten los datos de la iglesia en información útil para
              decidir. El Pastor puede ver con exactitud cómo está creciendo y cómo se está
              distribuyendo la congregación, sin depender de planillas ni de reportes dispersos.
            </p>
            <p class="m-0 mt-3 line-height-3">
              Compará semanas, células y reuniones para reconocer cambios, encontrar oportunidades
              de acompañamiento y tomar decisiones con información real.
            </p>
            <p class="m-0 mt-3 text-sm text-color-secondary line-height-3">
              También podés consultar sexo, edades, bautismo y, cuando la iglesia los usa, niveles y
              reuniones.
            </p>
          </div>
          <div class="col-12 lg:col-6 inicio-revelar" style="transition-delay: 120ms">
            <div class="inicio-graficos-visual relative">
              <img
                class="inicio-foto inicio-foto-clara relative z-1 block w-full h-auto"
                src="assets/inicio/graficos.jpg"
                alt="Gráfico de asistencia, gráfico circular y tres indicadores de la congregación"
                width="1152"
                height="864"
                loading="lazy"
                decoding="async"
              />
              <div class="inicio-metricas absolute z-2 pointer-events-none">
                @for (metrica of metricas; track metrica.etiqueta) {
                  <p class="inicio-metrica flex flex-column align-items-center justify-content-center m-0 min-w-0 text-center" [attr.aria-label]="metrica.etiqueta + ': ' + metrica.objetivo">
                    <span class="inicio-metrica-valor inline-flex align-items-center justify-content-center gap-1 min-w-0" aria-hidden="true">
                      <i [class]="metrica.icono + ' inicio-metrica-icono flex-none line-height-1'"></i>
                      <strong class="font-bold line-height-1">{{ metrica.valor() }}</strong>
                    </span>
                    <span aria-hidden="true">{{ metrica.etiqueta }}</span>
                  </p>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="inicio-bloque inicio-bloque-mapa py-6" aria-labelledby="mapa-titulo">
      <div class="inicio-wrap mx-auto">
        <div class="grid align-items-center">
          <div class="col-12 lg:col-7 inicio-revelar">
            <p-tag value="Una mirada diferente" [rounded]="true" />
            <h2 id="mapa-titulo" class="font-bold m-0 mt-3">El Pastor también puede ver dónde está su iglesia.</h2>
            <p class="m-0 mt-3 line-height-3">
              Cada célula es parte de una misma comunidad, aunque se reúna en distintos lugares.
              Con el mapa de células, el Pastor puede visualizar su distribución y tener una
              perspectiva territorial de la iglesia.
            </p>
            <div class="grid mt-3">
              <div class="col-12 md:col-6">
                <div class="inicio-dato flex align-items-start gap-3 h-full p-3 border-round-3xl">
                  <i class="pi pi-map-marker flex-none inline-flex align-items-center justify-content-center border-circle" aria-hidden="true"></i>
                  <div>
                    <strong class="block text-base">Ubicación clara</strong>
                    <span class="block mt-1 text-sm line-height-3">Encontrá las células de un vistazo.</span>
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-6">
                <div class="inicio-dato flex align-items-start gap-3 h-full p-3 border-round-3xl">
                  <i class="pi pi-sitemap flex-none inline-flex align-items-center justify-content-center border-circle" aria-hidden="true"></i>
                  <div>
                    <strong class="block text-base">Liderazgo visible</strong>
                    <span class="block mt-1 text-sm line-height-3">Relacioná cada grupo con su líder.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 lg:col-5 inicio-revelar" style="transition-delay: 120ms">
            <div class="inicio-mapa-visual relative flex align-items-center justify-content-center w-full max-w-18rem lg:max-w-22rem mx-auto overflow-visible" aria-hidden="true">
              <img
                class="inicio-mapa-img block w-full h-auto pointer-events-none select-none"
                src="assets/inicio/mapa-buenos-aires-3d.png"
                alt=""
                width="480"
                height="640"
                loading="lazy"
                decoding="async"
              />
              <span class="inicio-mapa-punto inicio-mapa-punto-1 absolute z-2 flex align-items-center justify-content-center border-circle text-white"><i class="pi pi-map-marker"></i></span>
              <span class="inicio-mapa-punto inicio-mapa-punto-2 absolute z-2 flex align-items-center justify-content-center border-circle text-white"><i class="pi pi-map-marker"></i></span>
              <span class="inicio-mapa-punto inicio-mapa-punto-3 absolute z-2 flex align-items-center justify-content-center border-circle text-white"><i class="pi pi-map-marker"></i></span>
              <span class="inicio-mapa-punto inicio-mapa-punto-4 absolute z-2 flex align-items-center justify-content-center border-circle text-white"><i class="pi pi-map-marker"></i></span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="roles" class="inicio-bloque py-6" aria-labelledby="roles-titulo">
      <div class="inicio-wrap mx-auto">
        <div class="inicio-encabezado mb-2 inicio-revelar">
          <p-tag value="Quién entra" [rounded]="true" severity="secondary" />
          <h2 id="roles-titulo" class="font-bold m-0 mt-3">El equipo que acompaña la visión del Pastor.</h2>
        </div>
        <div class="grid mt-2">
          @for (rol of roles; track rol.titulo; let i = $index) {
            <div class="col-12 md:col-6 inicio-revelar" [style.transition-delay.ms]="i * 90">
              <p-card styleClass="h-full inicio-panel">
                <span class="inicio-icono inline-flex align-items-center justify-content-center border-circle" aria-hidden="true"><i [class]="rol.icon"></i></span>
                <h3 class="m-0 mt-3 text-lg">{{ rol.titulo }}</h3>
                <p class="m-0 mt-2 text-sm line-height-3 text-color-secondary">{{ rol.texto }}</p>
              </p-card>
            </div>
          }
        </div>
      </div>
    </section>

    <section id="contacto" class="inicio-bloque inicio-bloque-suave py-6" aria-labelledby="contacto-titulo">
      <div class="inicio-wrap mx-auto">
        <div class="grid">
          <div class="col-12 lg:col-5 inicio-revelar">
            <p-tag value="Contacto" [rounded]="true" />
            <h2 id="contacto-titulo" class="font-bold m-0 mt-3">Quiero que me contacten</h2>
            <p class="m-0 mt-3 line-height-3">
              Dejá tu nombre, el de tu iglesia, tu celular, dónde estás y en qué horario preferís que te llamemos.
            </p>
          </div>
          <div class="col-12 lg:col-7 inicio-revelar" style="transition-delay: 120ms">
            <p-card styleClass="inicio-panel">
              @if (enviado()) {
                <div aria-live="polite">
                  <h3 class="m-0 text-lg">Recibimos tu pedido.</h3>
                  <p class="m-0 mt-2 text-color-secondary line-height-3">
                    Te vamos a contactar en el horario que elegiste.
                  </p>
                </div>
                <p-button
                  styleClass="mt-3"
                  type="button"
                  label="Enviar otro"
                  [outlined]="true"
                  (onClick)="enviado.set(false)"
                />
              } @else {
                <form class="grid" [formGroup]="contactoForm" (ngSubmit)="enviarContacto()">
                  <div class="col-12 md:col-6 flex flex-column gap-1">
                    <label class="text-sm font-medium" for="contacto-nombre">Nombre y apellido</label>
                    <input
                      pInputText
                      id="contacto-nombre"
                      name="nombre"
                      type="text"
                      formControlName="nombre"
                      autocomplete="name"
                      class="w-full"
                    />
                    @if (contactoForm.controls.nombre.invalid && contactoForm.controls.nombre.touched) {
                      <small class="text-red-500 text-xs" aria-live="polite">Ingresá tu nombre y apellido.</small>
                    }
                  </div>
                  <div class="col-12 md:col-6 flex flex-column gap-1">
                    <label class="text-sm font-medium" for="contacto-iglesia">Nombre de la iglesia</label>
                    <input
                      pInputText
                      id="contacto-iglesia"
                      name="iglesia"
                      type="text"
                      formControlName="iglesia"
                      autocomplete="organization"
                      class="w-full"
                    />
                    @if (contactoForm.controls.iglesia.invalid && contactoForm.controls.iglesia.touched) {
                      <small class="text-red-500 text-xs" aria-live="polite">Ingresá el nombre de la iglesia.</small>
                    }
                  </div>
                  <div class="col-12 flex flex-column gap-1">
                    <label class="text-sm font-medium" for="contacto-celular">Celular</label>
                    <input
                      pInputText
                      id="contacto-celular"
                      name="celular"
                      type="tel"
                      formControlName="celular"
                      placeholder="11 5555 5555…"
                      autocomplete="tel"
                      class="w-full"
                    />
                    @if (contactoForm.controls.celular.invalid && contactoForm.controls.celular.touched) {
                      <small class="text-red-500 text-xs" aria-live="polite">Ingresá un celular válido.</small>
                    }
                  </div>
                  <div class="col-12 md:col-6 flex flex-column gap-1">
                    <label class="text-sm font-medium" for="contacto-pais">País</label>
                    <p-select
                      inputId="contacto-pais"
                      name="pais"
                      [options]="paises"
                      formControlName="pais"
                      appendTo="body"
                      styleClass="w-full"
                      (onChange)="alCambiarPais()"
                    />
                  </div>
                  @if (esOtroPais()) {
                    <div class="col-12 md:col-6 flex flex-column gap-1">
                      <label class="text-sm font-medium" for="contacto-pais-otro">Cuál país</label>
                      <input
                        pInputText
                        id="contacto-pais-otro"
                        name="paisOtro"
                        type="text"
                        formControlName="paisOtro"
                        autocomplete="country-name"
                        class="w-full"
                      />
                      @if (contactoForm.controls.paisOtro.invalid && contactoForm.controls.paisOtro.touched) {
                        <small class="text-red-500 text-xs" aria-live="polite">Escribí el país.</small>
                      }
                    </div>
                  }
                  <div class="col-12 md:col-6 flex flex-column gap-1">
                    <label class="text-sm font-medium" for="contacto-provincia">
                      {{ esArgentina() ? 'Provincia' : 'Provincia o estado' }}
                    </label>
                    @if (esArgentina()) {
                      <p-select
                        inputId="contacto-provincia"
                        name="provincia"
                        [options]="provinciasArgentina"
                        formControlName="provincia"
                        placeholder="Elegí una provincia…"
                        appendTo="body"
                        styleClass="w-full"
                      />
                    } @else {
                      <input
                        pInputText
                        id="contacto-provincia"
                        name="provincia"
                        type="text"
                        formControlName="provincia"
                        autocomplete="address-level1"
                        class="w-full"
                      />
                    }
                    @if (contactoForm.controls.provincia.invalid && contactoForm.controls.provincia.touched) {
                      <small class="text-red-500 text-xs" aria-live="polite">La provincia es obligatoria.</small>
                    }
                  </div>
                  <div class="col-12 flex flex-column gap-1">
                    <label class="text-sm font-medium" for="contacto-horario">Horario de preferencia</label>
                    <p-select
                      inputId="contacto-horario"
                      name="horario"
                      [options]="horarios"
                      formControlName="horario"
                      placeholder="Elegí un horario…"
                      appendTo="body"
                      styleClass="w-full"
                      (onChange)="alCambiarHorario()"
                    />
                    @if (contactoForm.controls.horario.invalid && contactoForm.controls.horario.touched) {
                      <small class="text-red-500 text-xs" aria-live="polite">Elegí un horario.</small>
                    }
                  </div>
                  @if (esHoraEspecifica()) {
                    <div class="col-12 md:col-6 flex flex-column gap-1">
                      <label class="text-sm font-medium" for="contacto-hora">Hora</label>
                      <input
                        pInputText
                        id="contacto-hora"
                        name="hora"
                        type="time"
                        formControlName="hora"
                        class="w-full"
                      />
                      @if (contactoForm.controls.hora.invalid && contactoForm.controls.hora.touched) {
                        <small class="text-red-500 text-xs" aria-live="polite">Elegí una hora.</small>
                      }
                    </div>
                  }
                  <div class="col-12 flex flex-column gap-1">
                    <label class="text-sm font-medium" for="contacto-nota">Nota</label>
                    <textarea
                      pTextarea
                      id="contacto-nota"
                      name="nota"
                      rows="4"
                      class="w-full"
                      formControlName="nota"
                      [maxlength]="notaMax"
                      autocomplete="off"
                      placeholder="Contanos lo que quieras…"
                    ></textarea>
                    <small class="text-color-secondary text-right">
                      {{ contactoForm.controls.nota.value.length }}/{{ notaMax }}
                    </small>
                  </div>
                  <div class="col-12">
                    <p-button
                      type="submit"
                      label="Quiero que me contacten"
                      icon="pi pi-send"
                      [loading]="enviando()"
                    />
                  </div>
                </form>
              }
            </p-card>
          </div>
        </div>
      </div>
    </section>

    <section class="inicio-cierre pb-6" aria-labelledby="cierre-titulo">
      <div class="inicio-wrap mx-auto inicio-revelar">
        <a [routerLink]="rutaEntrada" class="inicio-cierre-banda relative flex w-full align-items-center lg:align-items-end justify-content-between gap-4 overflow-hidden cursor-pointer text-left no-underline">
          <div class="inicio-cierre-copy relative z-1 max-w-28rem">
            <p class="text-base m-0">
              {{ conSesion ? 'Tu sesión sigue abierta en este navegador.' : 'Entrá con el correo de tu iglesia.' }}
            </p>
            <h2 id="cierre-titulo" class="font-bold m-0">Entrar</h2>
          </div>
          <span class="inicio-cierre-flecha relative z-1 flex align-items-center justify-content-center border-circle text-white text-xl align-self-start" aria-hidden="true">
            <i class="pi pi-arrow-up-right"></i>
          </span>
        </a>
      </div>
    </section>
  </main>

  <footer class="inicio-footer">
    <div class="inicio-wrap mx-auto flex flex-column sm:flex-row align-items-start sm:align-items-center justify-content-between gap-3 py-4">
      <div class="inicio-footer-marca flex flex-column md:flex-row align-items-start md:align-items-center gap-2 md:gap-3" translate="no">
        <img
          src="assets/marca/mayorap-logo-blanco.png"
          alt="Mayorap"
          width="1024"
          height="288"
          loading="lazy"
          decoding="async"
        />
        <span class="text-sm">Sistema para iglesias</span>
      </div>
      <a [routerLink]="rutaEntrada" class="inicio-footer-link underline cursor-pointer border-none bg-transparent border-round">
        {{ conSesion ? 'Entrar' : 'Iniciar sesión' }}
      </a>
    </div>
  </footer>
</div>
